export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const WORKER_TYPE = "WORKER_TYPE";
export const FOREMAN_TYPE = "FOREMAN_TYPE";
